"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const Actor = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 18,
  height: 18,
  viewBox: "0 0 18 18"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  d: "M9 0a9 9 0 110 18A9 9 0 019 0zm0 2a7 7 0 100 14A7 7 0 009 2zm0 4a3 3 0 110 6 3 3 0 010-6z",
  fill: "#BBC4CD",
  fillRule: "evenodd",
  className: "fill"
}));
var _default = exports.default = Actor;